module.exports = __webpack_public_path__ + "img/sp_article_8.0c767649.jpg";